import React from "react";
import styles from "./Partners.module.css";
import img1 from "../../../assets/images/robotics/glimpses/img2303.jpg";
import img2 from "../../../assets/images/robotics/glimpses/img2305.jpg";
import img3 from "../../../assets/images/robotics/glimpses/img2307.jpg";
import img4 from "../../../assets/images/robotics/glimpses/img2309.jpg";
import img5 from "../../../assets/images/robotics/glimpses/img2311.jpg";
import img6 from "../../../assets/images/robotics/glimpses/img2313.jpg";
import schools from "../../../assets/images/robotics/glimpses/img2315.jpg";
import img7 from "../../../assets/images/robotics/glimpses/img2318.jpg";

const Partners = () => {
  const partners = [
    {
      category: "Educational Institutions",
      logos: [
        { logo: img2 },
        { logo: img3 },
        { logo: img4 },
        { logo: img5 },
        { logo: img6 },
        { logo: img7 },
      ],
    },
  ];

  return (
    <section className={styles.partners}>
      <div className={styles.container}>
        <h2 className={styles.title}>
          <span className={styles.highlight}>Glimpses of </span>IRL
        </h2>
        <img src={img1} className={styles.glimpses} />
        <div className={styles.logoGrid}>
          {/* We'll use CSS grid for a responsive, animated layout */}
          {partners.map((category, idx) => (
            <div key={idx} className={styles.category}>
              <h3>{category.title}</h3>
              <div className={styles.logos}>
                {category.logos.map((partner, index) => (
                  <div key={index} className={styles.logoCard}>
                    <img src={partner.logo} className={styles.logo} />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <h2 className={styles.title}>
        <span className={styles.highlight}>IRL</span> Partners
      </h2>
      <p className={styles.subtitle}>
        Proud to collaborate with over 150+ educational institutions
      </p>
      <img src={schools} className={styles.glimpsesschool} />
    </section>
  );
};

export default Partners;
